import { render, staticRenderFns } from "./SupplierRegistration.vue?vue&type=template&id=01412b06&scoped=true&"
import script from "./SupplierRegistration.vue?vue&type=script&lang=js&"
export * from "./SupplierRegistration.vue?vue&type=script&lang=js&"
import style0 from "./SupplierRegistration.vue?vue&type=style&index=0&id=01412b06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01412b06",
  null
  
)

export default component.exports